import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { httpRequest } from "utils/httpRequest";
import { Pagination } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { toast } from "react-toastify";
import CircleLoader from "components/loader/CircleLoader";
import { useLoader } from "components/loader/useLoader";

const ArticleManagement = () => {
  const { loading, startLoading, stopLoading } = useLoader();

  const [articlesData, setArticlesData] = useState([]);

  const [activePage, setActivePage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);

  // Sample data - you can replace this with your dynamic data
  const [data, setData] = useState([
    { id: 1, name: "Michael Schumaker", email: "john@example.com" },
    { id: 2, name: "Yuvraj Singh", email: "jane@example.com" },
    { id: 3, name: "James Anderson", email: "mike@example.com" },
    { id: 4, name: "Kane Wilson", email: "sarah@example.com" },
    { id: 5, name: "Dawne Brown", email: "tom@example.com" },
    { id: 6, name: "Lisa Davis", email: "lisa@example.com" },
    { id: 7, name: "Mark Taylor", email: "mark@example.com" },
  ]);

  const navigate = useNavigate();

  const handleDelete = async (id) => {
    try {
      const response = await httpRequest(
        `article/delete/${id}`,
        "DELETE",
        {},
        {},
        true,
        false
      );
      if (response?.code === 200) {
        toast.success("Articke deleted successfully");
        const newTotal = total - 1;
        const maxPages = Math.ceil(newTotal / limit);
        const newPage = activePage > maxPages ? maxPages : activePage;

        setTotal(newTotal);
        setActivePage(newPage);
        getArticles(newPage, limit);
      }
    } catch (error) {
      console.error("delete error:", error);
      toast.error("Something went wrong");
    }
  };

  const handleEdit = (articleId) => {
    navigate(`/admin/edit-article/${articleId}`);
  };

  const handleNavigationOnAddArticle = () => {
    navigate("/admin/add-article");
  };

  const getArticles = async (page = 1, limit = 10) => {
    startLoading();
    try {
      const response = await httpRequest(
        "article/list",
        "GET",
        {},
        {
          page: page,
          limit: limit,
        },
        true,
        false
      );
      if (response?.code === 200) {
        setArticlesData(response?.data);
        setTotal(response?.total);
        setActivePage(response?.page);
        setLimit(response?.limit);
      }
    } catch (error) {
      console.error("Upload error:", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    getArticles(activePage, limit);
  }, []);

  const handlePageChange = (page) => {
    setActivePage(page);
    getArticles(page, limit);
  };

  return (
    <>
      {loading ? (
        <CircleLoader />
      ) : (
        <div className="container-fluid py-4 mt-5">
          <div className="row">
            <div className="col">
              <div className="card shadow">
                {/* Card Header */}
                <div className="card-header border-0 d-flex justify-content-end">
                  <h3 className="mb-0 mr-auto">Article Management</h3>
                  <Button
                    color="primary"
                    size="sm"
                    onClick={handleNavigationOnAddArticle}
                  >
                    Add Article
                  </Button>
                </div>

                {/* Table */}
                <div className="table-responsive">
                  <table className="table align-items-center table-flush">
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">S.No</th>
                        <th scope="col">Title</th>

                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {articlesData &&
                        articlesData.length > 0 &&
                        articlesData.map((item, index) => (
                          <tr key={item._id}>
                            <td>
                              <span className="mb-0 text-sm font-weight-bold">
                                {(activePage - 1) * limit + index + 1}
                              </span>
                            </td>
                            <td>
                              <span className="mb-0 text-sm font-weight-bold">
                                {item?.title}
                              </span>
                            </td>

                            <td>
                              <button
                                className="btn  btn-sm"
                                onClick={() => handleEdit(item?._id)}
                                title="Delete"
                              >
                                <i
                                  className="fas fa-edit text-primary me-2"
                                  title="Edit"
                                ></i>
                              </button>
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => handleDelete(item._id)}
                                title="Delete"
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>

                {/* Card Footer with Pagination */}
                <div className="card-footer py-4">
                  <div className="d-flex justify-content-end">
                    <Pagination
                      size="sm"
                      total={total}
                      limit={limit}
                      activePage={activePage}
                      onChangePage={handlePageChange}
                      maxButtons={5}
                      prev
                      next
                      last
                      first
                      ellipsis
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ArticleManagement;
